import styled from 'styled-components';

export const PaymentPlatformsIconsStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

export const PaymentPlatformIconStyles = styled.div`
  width: 50px;
  aspect-ratio: 1.75;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: var(--platforms-icon-bg);
  padding: 5px;

  svg {
    width: 100%;
    height: 100%;
  }
`;
